export default "__VITE_ASSET__Bht1Nhye__"